import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sourceMode: localStorage.getItem("sourceMode") === 'true',
    recordMode: localStorage.getItem("recordMode") === 'true',
    streamMode: localStorage.getItem("streamMode") === 'true',
    vMixApi: localStorage.getItem("vMixApi") === 'true',
    mixerApi: localStorage.getItem("mixerApi") === 'true',
};

export const vMixButtonSlice = createSlice({
    name: "vMixButton",
    initialState,
    reducers: {
        setSourceMode: (state, action) => {
            state.sourceMode = action.payload;
        },
        setRecordMode: (state, action) => {
            state.recordMode = action.payload;
        },
        setStreamMode: (state, action) => {
            state.streamMode = action.payload;
        },
        setVMixApp: (state, action) => {
            state.vMixApi = action.payload;
        },
        setMixerApp: (state, action) => {
            state.mixerApi = action.payload;
        }
    },
});

export const {
    setRecordMode,
    setSourceMode,
    setStreamMode,
    setVMixApp,
    setMixerApp
} = vMixButtonSlice.actions;

export default vMixButtonSlice.reducer;